<template>
  <div class="crud_form_wrapper app_settings_class">
    <!-- Start:: Single Step Form Content -->
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #ef3405">{{ $t("SIDENAV.settings.general") }}</h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #ef3405">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- سعر توصيل الطرد -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.package_delivery_price')"
                v-model.trim="data.package_delivery_price"
                min="0"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.riyal") }}</span
              >
            </div>
          </div>

          <!-- سعر استرجاع الطرد للمندوب -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="
                  $t('settings.attributes.driver_package_return_price')
                "
                v-model.trim="data.driver_package_return_price"
                min="0"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.riyal") }}</span
              >
            </div>
          </div>

          <!-- نسبة عمولة المندوب -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.driver_commission')"
                v-model.trim="data.driver_commission"
                min="0"
                max="100"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 18px;
                  color: #666;
                "
                >%</span
              >
            </div>
          </div>

          <!-- نسبة عمولة نقطة التوزيع -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="
                  $t('settings.attributes.distribution_point_commission')
                "
                v-model.trim="data.distribution_point_commission"
                min="0"
                max="100"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 18px;
                  color: #666;
                "
                >%</span
              >
            </div>
          </div>

          <!-- نسبة عمولة النظام -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.system_commission')"
                v-model.trim="data.system_commission"
                min="0"
                max="100"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 18px;
                  color: #666;
                "
                >%</span
              >
            </div>
          </div>

          <!-- فترة السماح قبل تفعيل زر الاسترجاع -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.return_activation_days')"
                v-model.trim="data.return_activation_days"
                min="0"
                max="10"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.day") }}</span
              >
            </div>
          </div>

          <!-- مدة الاستلام بعد قبول الحزمة -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.pickup_timeout_minutes')"
                v-model.trim="data.pickup_timeout_minutes"
                min="0"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.minute") }}</span
              >
            </div>
          </div>

          <!-- فترة السماح قبل تعليق الطرد -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.package_hold_minutes')"
                v-model.trim="data.package_hold_minutes"
                min="0"
                max="200"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.minute") }}</span
              >
            </div>
          </div>

          <!-- نطاق استقبال الحزم -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.bundle_search_range')"
                v-model.trim="data.bundle_search_range"
                min="1"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.kilometer") }}</span
              >
            </div>
          </div>

          <!-- الحد الأقصى لنطاق الحزمة -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.max_bundle_radius')"
                v-model.trim="data.max_bundle_radius"
                min="0"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.kilometer") }}</span
              >
            </div>
          </div>

          <!-- الحد الأقصى لنطاق السائق -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.driver_max_radius')"
                v-model.trim="data.driver_max_radius"
                min="0"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.kilometer") }}</span
              >
            </div>
          </div>

          <!-- نطاق البحث عن سائق في الاسترجاع -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper" style="position: relative">
              <base-input
                type="number"
                col="12"
                :placeholder="
                  $t('settings.attributes.driver_return_max_radius')
                "
                v-model.trim="data.driver_return_max_radius"
                min="0"
                required
              />
              <span
                style="
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 14px;
                  color: #666;
                "
                >{{ $t("PLACEHOLDERS.kilometer") }}</span
              >
            </div>
          </div>

          <!-- الحد الأدنى لعدد الطرود في الحزمة -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.min_bundle_packages')"
                v-model.trim="data.min_bundle_packages"
                min="1"
                required
              />
            </div>
          </div>

          <!-- الحد الأقصى لعدد الطرود في الحزمة -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="input_wrapper">
              <base-input
                type="number"
                col="12"
                :placeholder="$t('settings.attributes.max_bundle_packages')"
                v-model.trim="data.max_bundle_packages"
                min="1"
                required
              />
            </div>
          </div>

          <!-- إظهار طريقة التوصيل المباشر -->
          <base-switch-input
            col="6"
            :label="$t('settings.attributes.is_direct_delivery_method_show')"
            v-model="data.is_direct_delivery_method_show"
          />

          <!-- إظهار طريقة التوصيل عبر نقطة التوزيع -->
          <base-switch-input
            col="6"
            :label="$t('settings.attributes.is_dis_point_delivery_method_show')"
            v-model="data.is_dis_point_delivery_method_show"
          />

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppSetting",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        package_delivery_price: null,
        driver_package_return_price: null,
        driver_commission: null,
        distribution_point_commission: null,
        system_commission: null,
        return_activation_days: null,
        pickup_timeout_minutes: null,
        package_hold_minutes: null,
        bundle_search_range: null,
        max_bundle_radius: null,
        driver_max_radius: null,
        driver_return_max_radius: null,
        min_bundle_packages: null,
        max_bundle_packages: null,
        is_direct_delivery_method_show: false,
        is_dis_point_delivery_method_show: false,
        // End:: Data
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      getAuthenticatedUserData: "AuthenticationModule/getAuthenticatedUserData",
    }),
    // End:: Vuex Getters
  },

  methods: {
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings?key=general`,
        });
        const settings = res.data.data.data[0]?.value;
        this.data.package_delivery_price = settings.package_delivery_price;
        this.data.driver_package_return_price =
          settings.driver_package_return_price;
        this.data.driver_commission = settings.driver_commission;
        this.data.distribution_point_commission =
          settings.distribution_point_commission;
        this.data.system_commission = settings.system_commission;
        this.data.return_activation_days = settings.return_activation_days;
        this.data.pickup_timeout_minutes = settings.pickup_timeout_minutes;
        this.data.package_hold_minutes = settings.package_hold_minutes;
        this.data.bundle_search_range = settings.bundle_search_range;
        this.data.max_bundle_radius = settings.max_bundle_radius;
        this.data.driver_max_radius = settings.driver_max_radius;
        this.data.driver_return_max_radius = settings.driver_return_max_radius;
        this.data.min_bundle_packages = settings.min_bundle_packages;
        this.data.max_bundle_packages = settings.max_bundle_packages;
        this.data.is_direct_delivery_method_show =
          +settings.is_direct_delivery_method_show ? true : false;
        this.data.is_dis_point_delivery_method_show =
          +settings.is_dis_point_delivery_method_show ? true : false;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = true;

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "general");

      if (this.data.package_delivery_price !== null) {
        REQUEST_DATA.append(
          "value[package_delivery_price]",
          this.data.package_delivery_price
        );
      }
      if (this.data.driver_package_return_price !== null) {
        REQUEST_DATA.append(
          "value[driver_package_return_price]",
          this.data.driver_package_return_price
        );
      }
      if (this.data.driver_commission !== null) {
        REQUEST_DATA.append(
          "value[driver_commission]",
          this.data.driver_commission
        );
      }
      if (this.data.distribution_point_commission !== null) {
        REQUEST_DATA.append(
          "value[distribution_point_commission]",
          this.data.distribution_point_commission
        );
      }
      if (this.data.system_commission !== null) {
        REQUEST_DATA.append(
          "value[system_commission]",
          this.data.system_commission
        );
      }
      if (this.data.return_activation_days !== null) {
        REQUEST_DATA.append(
          "value[return_activation_days]",
          this.data.return_activation_days
        );
      }
      if (this.data.pickup_timeout_minutes !== null) {
        REQUEST_DATA.append(
          "value[pickup_timeout_minutes]",
          this.data.pickup_timeout_minutes
        );
      }
      if (this.data.package_hold_minutes !== null) {
        REQUEST_DATA.append(
          "value[package_hold_minutes]",
          this.data.package_hold_minutes
        );
      }
      if (this.data.bundle_search_range !== null) {
        REQUEST_DATA.append(
          "value[bundle_search_range]",
          this.data.bundle_search_range
        );
      }
      if (this.data.max_bundle_radius !== null) {
        REQUEST_DATA.append(
          "value[max_bundle_radius]",
          this.data.max_bundle_radius
        );
      }
      if (this.data.driver_max_radius !== null) {
        REQUEST_DATA.append(
          "value[driver_max_radius]",
          this.data.driver_max_radius
        );
      }
      if (this.data.driver_return_max_radius !== null) {
        REQUEST_DATA.append(
          "value[driver_return_max_radius]",
          this.data.driver_return_max_radius
        );
      }
      if (this.data.min_bundle_packages !== null) {
        REQUEST_DATA.append(
          "value[min_bundle_packages]",
          this.data.min_bundle_packages
        );
      }
      if (this.data.max_bundle_packages !== null) {
        REQUEST_DATA.append(
          "value[max_bundle_packages]",
          this.data.max_bundle_packages
        );
      }
      REQUEST_DATA.append(
        "value[is_direct_delivery_method_show]",
        this.data.is_direct_delivery_method_show ? 1 : 0
      );
      REQUEST_DATA.append(
        "value[is_dis_point_delivery_method_show]",
        this.data.is_dis_point_delivery_method_show ? 1 : 0
      );

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: Validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style>
.app_settings_class form .input_wrapper.top_label .form-label {
  font-size: 14px !important;
  top: -10px !important;
}
@media (max-width: 1080px) {
  .app_settings_class form .input_wrapper.top_label .form-label {
    font-size: 13px !important;
    top: -10px !important;
  }
  .app_settings_class form .input_wrapper.top_label input,
  .app_settings_class
    form
    .input_wrapper.top_label.select_wrapper
    .multiselect
    .multiselect__tags {
    padding: 30px 12px !important;
  }
}
</style>

<style lang="scss" scoped>
.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
